export const dataSetup = (typ, data) => {
  let chartData = null;
  let groups = null;

  if (typ === 0) {
    if (data[0]['#group']) {
      groups = [];

      data.forEach((e) => {
        const group = e['#group'];

        if (!groups.includes(group)) {
          groups.push(group);
        }
      });
    }
  } else if (typ === 1 || typ === 2) {
    const keys = Object.keys(data[0]);
    const xAxisField = keys.shift();

    const series = keys.map((e) => ({
      value: e,
      name: e
    }));

    chartData = {
      xAxisField,
      series,
      values: data
    };
  }

  return { chartData, groups };
};

const addZeroToDateString = (date) => {
  if (date < 10) {
    return `0${date}`;
  }

  return date;
};

export const getProperDate = () => {
  const genDate = new Date();
  const year = genDate.getFullYear();
  const month = addZeroToDateString(genDate.getMonth() + 1);
  const day = addZeroToDateString(genDate.getDate());
  const hours = addZeroToDateString(genDate.getHours());
  const minutes = addZeroToDateString(genDate.getMinutes());

  return `${year}-${month}-${day} ${hours}:${minutes}`;
};
